module.exports = __webpack_public_path__ + "static/media/triangle-danger.5e9afc1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/triangle-danger.jpg
// module id = 676
// module chunks = 0